<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Lançamento de BPA individualizado"
    >
        <Form
            :id="id"
            :origem="origem"
            @save="handleExit"
            ref="Form"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
                color="secondary"
            >
                Fechar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="$refs.Form.save()"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        id: null,
        origem: null,
    }),
    methods: {
        open(item) {
            this.id = item.id
            this.origem = item.origem
            this.$refs.RkmModal.show()
        },
        handleExit() {
            this.$emit('close')
            this.$refs.RkmModal.hide()
        },
    },
}
</script>